import { Outlet } from 'react-router-dom';
import { MainContainer } from './base.styles';
import React from 'react';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';

const BasePage = React.memo(() => {
  return (
    <ErrorBoundary>
      <MainContainer>
        <Outlet />
      </MainContainer>
    </ErrorBoundary>
  );
});

BasePage.displayName = 'BasePage';

export default BasePage;
